import { Button, Stack, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { updateNote } from '../../../../redux/features/crdMigrationSlice';

const AddNoteModalContent = ({ row, setOpenModal, setRefresh }) => {
  const [note, setNote] = useState(row?.accounts_notes || '');
  const submitLoading = useSelector((state) => state.crdMigration.submitLoading);

  const dispatch = useDispatch();
  const apiHelper = useHandleApiResponse();
  const submitHanlder = (e) => {
    e.preventDefault();
    const data = {
      accounts_entity_id: row?.accounts_entity_id,
      notes: note,
    };
    dispatch(updateNote(data)).then((res) =>
      apiHelper(res, {
        onSuccess: () => {
          setOpenModal(false);
          setRefresh((prev) => !prev);
          setNote('');
        },
      }),
    );
  };
  return (
    <form onSubmit={submitHanlder}>
      <Stack gap={2}>
        <TextField multiline label="Note" rows={4} onChange={(e) => setNote(e.target.value)} value={note} />
        <Button type="submit" variant="contained" disabled={submitLoading}>
          {submitLoading ? 'Updating...' : 'Update'}
        </Button>
      </Stack>
    </form>
  );
};

export default React.memo(AddNoteModalContent);
